import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import TechStackPage from '../components/TechStackPage.vue';
import CertificatesPage from '../components/CertificatesPage.vue';
import AllProjectsPage from '../components/AllProjectsPage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/techstack',
    name: 'TechStack',
    component: TechStackPage,
  },
  {
    path: '/certificates',
    name: 'Certificates',
    component: CertificatesPage,
  },
  {
    path: '/projects',
    name: 'Projects',
    component: AllProjectsPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else {
      return { top: 0 };
    }
  },
});

export default router;
